export default "__VITE_PUBLIC_ASSET__c6d8cdc6__"